import script from "./ArchiveConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArchiveConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ArchiveConfirmDialog.vue?vue&type=style&index=0&id=391ea7ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-391ea7ce"]])

export default __exports__